<div class="bottom-slider">
    <div *ngIf="tempLogos.length>0" style="text-align: center;font-weight: 600;line-height: 31px;font-size: 20px;}" i18n="@@Brands who trust in Searchia:">Brands who trust in Searchia:</div>
    <div class="slider-logo" [ngStyle]="{'to': 'left:400%'}" [style.]="">
        <ng-container *ngFor="let wlogo of tempLogos">
            <img *ngIf="logoType==2" style="{{opacity ? 'filter: opacity(0.5)' :'filter: opacity(0.9)'}}"
                 [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +wlogo['w-img-uid'] "
                 [alt]="wlogo['img-name']"/>
            <img *ngIf="logoType==1"  style="{{opacity ? 'filter: opacity(0.5)' :'filter: opacity(0.9)'}}"
                 [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +wlogo['c-img-uid'] "
                 [alt]="wlogo['img-name']"/>
        </ng-container>
    </div>
</div>
